


























import { Vue, Component, Prop } from 'vue-property-decorator';
import ProfileIcon from '../icons/ProfileIcon.vue';
import { AuthModule, UserRole, UserRoleName } from '@/store/modules/auth';
import { State } from 'vuex-class';

@Component({
  components: {
    ProfileIcon
  }
})
export default class NavBar extends Vue {
  logoutUrl = `${window.autoProcessConfiguration.apiUrl}/saml/logout`;

  get isAdministrator() {
    return AuthModule.user && AuthModule.user.roles && AuthModule.user.roles.includes(UserRole.administrator);
  }

  get isFrontpageEditor() {
    return AuthModule.user && AuthModule.user.roles.includes(UserRole.frontpageEditor);
  }

  get cvr() {
    return AuthModule.user?.cvr
  }

  get state() {
    return AuthModule;
  }

  get roles() {
    return AuthModule.user?.roles?.map(r => UserRoleName[r])?.join(', ') ?? '';
  }
}
